import { Component, Input, OnChanges } from '@angular/core';
import { RoadSegmentStatusService } from '../../../../data/road/road-segment-status.service';
import { RoadSegmentStatus } from '../../../models/road-status';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DatePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-road-status-info-window-content',
  templateUrl: './road-status-info-window-content.component.html',
  styleUrls: ['./road-status-info-window-content.component.scss'],
  imports: [MatProgressSpinner, MatTooltip, DatePipe],
})
export class RoadStatusInfoWindowContentComponent implements OnChanges {
  @Input() roadSegmentId: number;
  roadSegmentStatus: RoadSegmentStatus;
  isLoading = true;

  constructor(private roadSegmentStatusService: RoadSegmentStatusService) {}

  ngOnChanges(): void {
    this.roadSegmentStatusService
      .getRouteSegmentStatus(this.roadSegmentId)
      .then(response => {
        this.roadSegmentStatus = response.data;
        this.isLoading = false;
      })
      .catch(error => {
        console.error(error);
        this.isLoading = false;
      });
  }
}
